(() => {
  if (!customElements.get('lc-size-guide')) {
    customElements.define('lc-size-guide', class extends HTMLElement {
      connectedCallback() {
        this.abort?.abort();
        this.abort = new AbortController();
        const options = { signal: this.abort.signal };
        this.panels = Array.from(this.querySelectorAll('[data-size-panel]'));
        this.select = this.querySelector('[data-size-category]');
        this.tabs = Array.from(this.querySelectorAll('[data-size-tab]'));
        this.querySelectorAll('.lc-size-table table').forEach(table => {
          const rows = Array.from(table.rows);
          if (!rows.length) return;
          rows.forEach((row, rowIndex) => {
            Array.from(row.cells).forEach((cell, colIndex) => {
              if (cell.tagName === 'TD' && (rowIndex === 0 || colIndex === 0)) {
                const heading = document.createElement('th');
                heading.scope = rowIndex === 0 ? 'col' : 'row';
                heading.innerHTML = cell.innerHTML;
                heading.colSpan = cell.colSpan;
                heading.rowSpan = cell.rowSpan;
                cell.replaceWith(heading);
              }
            });
          });
          table.style.setProperty('--lc-table-columns', rows[0].cells.length);
        });
        this.select?.addEventListener('change', () => this.activate(this.select.value), options);
        this.addEventListener('click', event => {
          const tab = event.target.closest('[data-size-tab]');
          if (tab && this.contains(tab)) this.activate(tab.dataset.sizeTab);
          const unit = event.target.closest('[data-size-unit]');
          if (unit && this.contains(unit)) {
            const chart = unit.closest('[data-size-chart]');
            chart.querySelectorAll('[data-size-unit]').forEach(button => button.setAttribute('aria-pressed', String(button === unit)));
            chart.querySelectorAll('[data-size-table]').forEach(table => { table.hidden = table.dataset.sizeTable !== unit.dataset.sizeUnit; });
          }
        }, options);
        this.addEventListener('keydown', event => {
          const current = event.target.closest('[data-size-tab]');
          if (!current || !['ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(event.key)) return;
          event.preventDefault();
          let index = this.tabs.indexOf(current);
          if (event.key === 'Home') index = 0;
          else if (event.key === 'End') index = this.tabs.length - 1;
          else index = (index + (event.key === 'ArrowRight' ? 1 : -1) + this.tabs.length) % this.tabs.length;
          this.activate(this.tabs[index].dataset.sizeTab);
          this.tabs[index].focus();
        }, options);
        this.querySelector('[data-size-controls]')?.removeAttribute('hidden');
        this.querySelector('[data-size-fallback]')?.setAttribute('hidden', '');
        this.activate(this.select?.value || this.panels[0]?.id);
      }
      activate(id) {
        if (!this.panels.some(panel => panel.id === id)) return;
        this.panels.forEach(panel => { panel.hidden = panel.id !== id; });
        this.tabs.forEach(tab => {
          const active = tab.dataset.sizeTab === id;
          tab.setAttribute('aria-selected', String(active));
          tab.tabIndex = active ? 0 : -1;
        });
        if (this.select) this.select.value = id;
      }
      disconnectedCallback() { this.abort?.abort(); }
    });
  }
  let opener;
  document.addEventListener('click', event => {
    const trigger = event.target.closest('[data-lc-size-open], [data-toggle="CanvasSizeGuide"]');
    const dialog = document.getElementById('lc-size-dialog');
    if (!trigger || !dialog) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    opener = trigger;
    if (!dialog.open) {
      dialog.showModal();
      document.documentElement.classList.add('lc-size-dialog-open');
      dialog.querySelector('[data-lc-size-close]')?.focus({ preventScroll: true });
    }
  }, true);
  const dialog = document.getElementById('lc-size-dialog');
  if (dialog) {
    dialog.addEventListener('click', event => {
      if (event.target.closest('[data-lc-size-close]')) dialog.close();
      else if (event.target === dialog) {
        const box = dialog.getBoundingClientRect();
        if (event.clientX < box.left || event.clientX > box.right || event.clientY < box.top || event.clientY > box.bottom) dialog.close();
      }
    });
    dialog.addEventListener('close', () => {
      document.documentElement.classList.remove('lc-size-dialog-open');
      if (opener?.isConnected) opener.focus({ preventScroll: true });
    });
  }
})();
